import reg from '@/util/reg'

export default {
    /**
     * 判断是否为空
     * @param val           要判断的值
     * @returns {Boolean}   是否为null,undefined,''
     */
    isEmpty(val: any): boolean {
        return val == null || val === ''
    },

    /**
     * 判断是否为0
     * @param val           要判断的值
     * @returns {Boolean}   是否为0或'0'
     */
    isZero(val: any): boolean {
        return val === 0 || val === '0'
    },

    /**
     * 判断是否为数字
     * @param val           要判断的值
     * @returns {Boolean}   是否符合数字的正则
     */
    isNumber(val: any): boolean {
        return reg.reNumber.test(val)
    },

    /**
     * 是否为正数
     * @param val                   要判断的值
     * @param includeZero {Boolean} 是否包含0
     * @returns           {Boolean} 是否符合正数的正则
     */
    isPositiveNumber(val: any, includeZero = false): boolean {
        return (includeZero ? reg.rePositiveNumber : reg.rePositiveNumberNotZero).test(val)
    },

    /**
     * 是否为负数
     * @param val           要判断的值
     * @param includeZero {Boolean} 是否包含0
     * @returns {Boolean}   是否符合负数的正则
     */
    isNegativeNumber(val: any, includeZero = false): boolean {
        return (includeZero ? reg.reNegativeNumberHasZero : reg.reNegativeNumber).test(val)
    },

    /**
     * 是否为整数
     * @param val           要判断的值
     * @returns {Boolean}   是否符合整数的正则
     */
    isInt(val: any): boolean {
        return reg.reInt.test(val)
    },

    /**
     * 是否为正整数
     * @param val                   要判断的值
     * @param includeZero {Boolean} 是否包含0
     * @returns           {Boolean} 是否符合正整数的正则
     */
    isPositiveInt(val: any, includeZero = true): boolean {
        return (includeZero ? reg.rePositiveInt : reg.rePositiveIntNotZero).test(val)
    },

    /**
     * 是否为负整数
     * @param val           要判断的值
     * @param includeZero {Boolean} 是否包含0
     * @returns {Boolean}   是否符合负整数的正则
     */
    isNegativeInt(val: any, includeZero = true): boolean {
        return (includeZero ? reg.reNegativeIntHasZero : reg.reNegativeInt).test(val)
    },

    /**
     * 是否为合法的邮箱
     * @param val           要判断的值
     * @returns {Boolean}   是否符合负整数的正则
     */
    isEmail(val: any): boolean {
        return reg.reEmail.test(val)
    },

    /**
     * 是否为合法的密码(6~12位字母加数字)
     * @param val           要判断的值
     * @returns {Boolean}   是否符合负整数的正则
     */
    isValidPassword(val: any): boolean {
        return /[A-Za-z]+/.test(val) && /[\d]+/.test(val) && /^[A-Za-z\d]{6,12}$/.test(val)
    },

    /**
     * 是否为合法的密码(8~12位字母加数字加特殊符号)
     * @param val           要判断的值
     * @returns {Boolean}   是否符合负整数的正则
     */
    // ?=.*
    isValidNewPassword(val: any): boolean {
        return /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,12}$/.test(val)
    },

    /**
     * 是否为合法的手机号
     * @param val           要判断的值
     * @returns {Boolean}   是否符合负整数的正则
     */
    isValidMobile(val: any): boolean {
        return reg.reChinaMobile.test(val) || reg.reSingaporeMobile.test(val)
    },
}
